module.exports = __webpack_public_path__ + "img/billing.7bd18dcd.svg";